/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { CdsCategoria } from "./CdsCategoria";
import * as t from "io-ts";

// required attributes
const CdsServizioR = t.interface({});

// optional attributes
const CdsServizioO = t.partial({
  categoria: CdsCategoria,

  categoriaId: t.Integer,

  descrizioneServizio: t.string,

  id: t.Integer,

  idServizio: t.string,

  version: t.Integer,

  xsdRiferimento: t.string
});

export const CdsServizio = t.intersection(
  [CdsServizioR, CdsServizioO],
  "CdsServizio"
);

export type CdsServizio = t.TypeOf<typeof CdsServizio>;
